import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CollectionPeriod')
export class CollectionPeriod {

  @JsonProperty('collection_period_id', Number)
  collectionPeriodId: number = 0;

  @JsonProperty('collection_id', Any)
  collectionId: number | null = null;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('start_date_timestamp', Number)
  startDateTimestamp: number = 0;

  @JsonProperty('end_date_timestamp', Number)
  endDateTimestamp: number = 0;
}
